/*
 * @Author: Teemo Ding
 * @Date: 2021-09-15 12:57:17
 * @LastEditTime: 2021-10-12 16:09:57
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Edit/SSLCertificate/index.tsx
 */
import {
  Alert,
  Button,
  Checkbox,
  Label,
  TextArea,
} from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import { SSLStatusType } from '@/src/types/common/domain';
import { Collapse, Form } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from '../css.module.less';

const { Item } = Form;
const { Panel } = Collapse;

const SSLCertificate = ({
  domain,
  confirmDomain,
  status,
  cancelSubmission,
  verifiedDate,
  expiresDate,
  oldStatus,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fold, setFold] = useState(false);
  const disabledAll = status == SSLStatusType.Pending || !domain;

  const renderAlert = (statusItem) =>
    statusItem == SSLStatusType.Pending ||
    statusItem == SSLStatusType.Invalid ||
    statusItem == SSLStatusType.Expired ? (
      <Alert
        className={css.certificateAlert}
        {...(statusItem == SSLStatusType.Pending
          ? {
              action: (
                <Button className={css.infoType} onClick={cancelSubmission}>
                  {getI18n('salesChannelDomainAndStatus.edit.cancelSubmission')}
                </Button>
              ),
            }
          : {})}
        closable={
          statusItem == SSLStatusType.Pending ||
          statusItem == SSLStatusType.Expired
            ? false
            : true
        }
        message={
          statusItem == SSLStatusType.Pending
            ? getI18n('salesChannelDomainAndStatus.edit.certificateProcessing')
            : statusItem == SSLStatusType.Expired
            ? getI18n(
                'salesChannelDomainAndStatus.edit.sSLCertificateexpiressoon',
              )
            : getI18n('salesChannelDomainAndStatus.edit.sSLCertificateInvalid')
        }
        showIcon
        type={statusItem == SSLStatusType.Pending ? 'info' : 'error'}
        icon={
          <Icon
            type={
              statusItem == SSLStatusType.Pending ? 'iconpending' : 'iconfailed'
            }></Icon>
        }
        description={
          statusItem == SSLStatusType.Pending
            ? getI18n(
                'salesChannelDomainAndStatus.edit.certificateProcessingDes',
              )
            : statusItem == SSLStatusType.Expired
            ? getI18n(
                'salesChannelDomainAndStatus.edit.sSLCertificateexpiressoondesc',
              )
            : getI18n(
                'salesChannelDomainAndStatus.edit.sSLCertificateInvalidDesc',
              )
        }
      />
    ) : null;

  const renderItem = (
    <div>
      {renderAlert(status)}
      <div className={css.certificate}>
        <Item
          name={['certificate', 'certificate']}
          className={css.certificateItem}
          label={
            <Label
              title={`${getI18n(
                'salesChannelDomainAndStatus.edit.certificate',
              )}*`}
            />
          }
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('salesChannelDomainAndStatus.edit.certificate'),
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <TextArea disabled={disabledAll} size='large' />
        </Item>
        <Item
          name={['certificate', 'primaryKey']}
          className={css.certificateItem}
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('salesChannelDomainAndStatus.edit.privateKey'),
              ),
            },
          ]}
          label={
            <Label
              title={`${getI18n(
                'salesChannelDomainAndStatus.edit.privateKey',
              )}*`}
            />
          }
          labelCol={{ span: 24 }}>
          <TextArea disabled={disabledAll} size='large' />
        </Item>
      </div>

      <Item
        name={['certificate', 'certificateAuthorityBundle']}
        className={css.certificateItem}
        label={
          <Label
            title={getI18n(
              'salesChannelDomainAndStatus.edit.certificateAuthorityBundle',
            )}
          />
        }
        labelCol={{ span: 24 }}>
        <TextArea disabled={disabledAll} size='large' />
      </Item>
      <Item name={['certificate', 'notify']} valuePropName='checked'>
        <Checkbox disabled={disabledAll}>
          {getI18n('salesChannelDomainAndStatus.edit.certificatenotifylabel')}
        </Checkbox>
      </Item>
      <Button
        type='primary'
        onClick={() =>
          confirmDomain([
            ['certificate', 'certificate'],
            ['certificate', 'primaryKey'],
            ['certificate', 'certificateAuthorityBundle'],
            ['certificate', 'notify'],
            ['domain'],
          ])
        }
        disabled={disabledAll}
        className={css.primaryButton}>
        {getI18n('salesChannelDomainAndStatus.edit.submit')}
      </Button>
    </div>
  );

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      titleOnClick={() => setFold(!fold)}
      rightPart={<Icon type={fold ? 'icondown1' : 'iconright'}></Icon>}
      hideContent={!fold}
      title={getI18n(
        'salesChannelDomainAndStatus.edit.secureSocketsLayerSSLCertificate',
      )}>
      {renderAlert(oldStatus)}
      {oldStatus == SSLStatusType.Verified && (
        <div className={css.certificateVerified}>
          <p className={css.certificateTitle}>
            {getI18n('salesChannelDomainAndStatus.edit.sSLCertificateVerified')}
          </p>
          <p className={css.verifiedData}>
            {verifiedDate &&
              `${getI18n(
                'salesChannelDomainAndStatus.edit.verifiedon',
              )} ${moment(verifiedDate).format('MMM DD, YYYY')}}`}
            {expiresDate &&
              `, ${getI18n('salesChannelDomainAndStatus.edit.expireson')}
            ${moment(expiresDate).format('MMM DD, YYYY')}`}
          </p>
        </div>
      )}

      {oldStatus == SSLStatusType.Verified ? (
        <Collapse className={css.collapse} ghost>
          <Panel
            key='1'
            header={getI18n(
              'salesChannelDomainAndStatus.edit.updateSSLCertificate',
            )}>
            {renderItem}
          </Panel>
        </Collapse>
      ) : (
        renderItem
      )}
    </SectionWrapper>
  );
};

export default SSLCertificate;
